<template>
  <van-popup :value="value" :style="{'--guide-line-left': guideLeft}" @click="onClickHideGuide">
    <div style="width:100vw;height:100vh">

      <Ripple/>
      <div class="text-center text-white mt-20" style="font-size:34px">
        Welcome to your first<br/>
        OMNI device！
      </div>
      <div class="flex flex-row guide-line-layout" v-if="isBrandUser">
        <van-image class="mt-2.5" :src="require('@/assets/icons/v2/icon_guide_line.png')" width="64" height="108"/>
        <span class="guide-text">1. Choose Connection Type</span>
      </div>
      <template v-if="isBrandUser">
        <div ref="guideLineNfcLayout" class="flex flex-row guide-line-nfc-layout">

          <van-image class="mt-2.5" :src="require('@/assets/icons/v2/icon_guide_line_nfc_brand.png')" width="54"
              height="56"/>
          <span class="guide-text">2. Read Your Device</span>
        </div>
      </template>
      <template v-else>
        <div ref="guideLineNfcLayout" class="flex flex-col items-center guide-line-nfc-layout" v-if="funcType === 2">
          <span class="guide-text ">Retrieve Your Device</span>
          <van-image class="mt-2" :src="require('@/assets/icons/v2/icon_guide_line_nfc.png')" width="16" height="53"/>
        </div>
      </template>
      <BottomGuideOperate ref="guideOperate" :func-type="funcType" @onRead="onReadClick"/>
    </div>
  </van-popup>
</template>

<script>
import BottomGuideOperate from "@/components/home/BottomGuideOperate.vue";
import userMixin from "@/mixins/userMixin";
import Ripple from "@/components/home/Ripple";

export default {
  name: "NFCGuide",
  components: { Ripple, BottomGuideOperate },
  mixins: [userMixin],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    funcType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      guideLeft: 0
    };
  },
  watch: {
    value(newVal) {
      if (!newVal) {
        return;
      }
      this.$nextTick(() => {
        if (this.isBrandUser) {
          const left = this.$refs.guideOperate.$refs.readBtn.offsetLeft;
          const width = this.$refs.guideOperate.$refs.readBtn.clientWidth;
          const guideLineNfcLayoutWidth = this.$refs.guideLineNfcLayout.clientWidth;
          this.guideLeft = `${left + width / 2}px`;
        } else {
          const left = this.$refs.guideOperate.$refs.connectBtn.offsetLeft;
          const width = this.$refs.guideOperate.$refs.connectBtn.clientWidth;
          const guideLineNfcLayoutWidth = this.$refs.guideLineNfcLayout.clientWidth;
          this.guideLeft = `${left + width / 2 - guideLineNfcLayoutWidth / 2}px`;
        }
      });
    }
  },
  methods: {
    onClickHideGuide() {
      if (this.funcType === 1) {
        this.$store.dispatch("bluetooth/setShowBtGuide", true);
        this.$emit("input", false);
      } else {
        this.$store.dispatch("nfc/setShowNfcGuide", true);
        this.$emit("input", false);
      }
    },

    onReadClick() {
      this.$emit("onRead");
    },
    onWriteClick() {
      this.$emit("onWrite");
    }
  },
  computed: {},
  mounted() {

  }
};
</script>

<style scoped lang="less">
.van-popup {
  background: black;
}

.guide-line-layout {
  position: fixed;
  left: 40px;
  bottom: calc(60px + env(safe-area-inset-bottom));
}

.guide-line-nfc-layout {
  position: fixed;
  left: var(--guide-line-left);
  bottom: calc(60px + env(safe-area-inset-bottom));
}

.guide-text {
  color: white;
  font-size: 16px;
  margin-top: 4px;
  margin-left: 10px;
}
</style>